import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Intro from './Intro';
import Nav from './Nav/Nav';
import Logo from 'logo.svg';
import { Link } from 'react-router-dom';
import { showSiteIntro, hideSiteIntro } from 'actions';
import get from 'lodash/get';
import throttle from 'lodash/throttle';
import { default as SM } from 'scrollmonitor';

class Header extends Component {
	constructor(props) {
		super(props);
		this.state = { isTop: false };
	}
	componentDidMount() {
		const throttledScroll = throttle( this.detectScroll, 100 );
		window.addEventListener( 'scroll', throttledScroll );
		this.detectScroll();
	}
	detectScroll = () => {
		const nowTop = (SM.viewportTop < 5);
		if ( nowTop !== this.state.isTop ) {
			this.setState({
				isTop: nowTop
			});
		}
	}
	hideSiteIntro = (e) => {
		if ( window.matchMedia("(min-width: 769px)").matches ) {
			if (e.relatedTarget !== window) this.props.hideIntro();
		}
	}
	showSiteIntro = (e) => {
		if ( window.matchMedia("(min-width: 769px)").matches && !this.props.disableIntro ) this.props.showIntro();
	}
	render() {
		const className = (this.state.isTop)? "is-top" : "is-not-top";
		return (
			<header id="Header" className={className} onMouseLeave={this.hideSiteIntro}>
				<div className="wrap">
					<h1>
						<Link to="/" id="Header-logo" onMouseEnter={this.showSiteIntro}><img src={Logo} alt={this.props.title} /></Link>
						<Link to="/about" id="Header-about">About</Link>
					</h1>

					<Nav />

					<Intro />
				</div>
			</header>
		)
	}
}
Header.propTypes = {
	title: PropTypes.string,
	disableIntro: PropTypes.bool
}
const mapStateToProps = (state) => {
	const pathname = get( state.status, ['pathname'] );
	return {
		title: get( state.config, ['site_title'], '' ),
		disableIntro: (pathname === '/about')
	}
}
const mapDispatchToProps = (dispatch) => {
	return {
		showIntro: () => { dispatch( showSiteIntro() ) },
		hideIntro: () => { dispatch( hideSiteIntro() ) },
	}
}
export default connect(mapStateToProps, mapDispatchToProps)(Header);


// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx